// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"Insurance_emptyWrapper__3F9dK","required-label":"Insurance_required-label__2y-Ub"};